import gql from "graphql-tag";

export const UPDATE_MEDICAL_STAFF = gql`
  mutation UpdateMedicalStaff(
    $data: MedicalStaffInput
    $where: MedicalStaffWhereUniqueInput
  ) {
    updateMedicalStaff(data: $data, where: $where) {
      id
    }
  }
`;

export const GET_MEDICAL_STAFFS = gql`
  query medicalStaffs($where: MedicalStaffWhereInput, $skip: Int, $take: Int) {
    medicalStaffs(where: $where, skip: $skip, take: $take) {
      id
      name
      firstName
      middleName
      lastName
      lastName2
      email
      phone
      enabled
      identificationCard
      exequatur
      phone
      specialitiesByMedical {
        speciality {
          id
          name
        }
      }
    }
    count: countMedical(where: $where)
  }
`;

export const GET_ARSES = gql`
  query GetArses($where: ARSWhereInput) {
    arses(where: $where) {
      id
      name
    }
  }
`;

export const GET_SPECIALITIES = gql`
  query specialities($where: SpecialityWhereInput) {
    specialities(where: $where) {
      id
      name
    }
  }
`;

export const GET_MEDICAL_STAFF = gql`
  query medicalStaff($where: MedicalStaffWhereUniqueInput) {
    medicalStaff(where: $where) {
      id
      firstName
      middleName
      lastName
      lastName2
      username
      phone
      phone2
      cellphone
      email
      exequatur
      address
      identificationCard
      municipalityId
      sectorId
      provinceId
      genderId
      legalPersonalityId
      userId

      arses {
        id
        code
        ars {
          id
          name
        }
      }
      medicalStaff {
        id
        providerId
        medicalStaffId
        profileId
        pharmacyProvider {
          id
          name
        }
        branchOffice {
          id
          name
        }
        profile {
          id
          name
        }
      }
      specialitiesByMedical {
        speciality {
          id
          name
        }
      }
    }
  }
`;

export const SAVE_MEDICAL_STAFF = gql`
  mutation saveMedicalStaff($data: MedicalStaffInput!) {
    saveMedicalStaff(data: $data) {
      id
    }
  }
`;

export const GET_PROVIDERS = gql`
  query getProviders {
    items: getProvidersToMedical {
      id
      name
    }
  }
`;

export const SAVE_USER = gql`
  mutation SaveUser($data: SaveUserInput!) {
    saveUser(data: $data) {
      id
    }
  }
`;

export const GET_BRANCH_OFFICES_BY_PROVIDER = gql`
  query branchOffices($where: BranchOfficeWhereInput) {
    branchOffices(where: $where) {
      id
      name
    }
  }
`;

export const DATA_PHARMACY_PROVIDERS_BY_NAME = gql`
  query pharmacyProvidersByName($where: PharmacyProviderWhereInput) {
    pharmacyProvidersByName(where: $where) {
      id
      name
      count
      commercialName
    }
  }
`;
